import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import SidebarStore from './SidebarStore';
import LogoIcon from '@app/src/common/components/logo/assets/Logo.svg';
import LogoMcube from '@app/src/common/components/logo/assets/logo_mcube.svg';
import AppsGridIcon from './assets/AppsGrid.svg';
import WordmarkIcon from './assets/Wordmark.svg';

const SidebarHeader: React.FC = () => {
  const isMcube = window.location.origin.includes('mcube');
  const BrandIcon = isMcube ? LogoMcube : LogoIcon;
  const isCollapsed = SidebarStore.collapsed;

  const handleTriggerClick = () => {
    if (SidebarStore.moduleSelectorOpen) {
      SidebarStore.closeModuleSelector();
    } else {
      SidebarStore.openModuleSelector();
    }
  };

  return (
    <div
      className={classNames('app-sidebar__header', {
        'app-sidebar__header_active': SidebarStore.moduleSelectorOpen
      })}
    >
      <button
        type="button"
        className={classNames('app-sidebar__module-trigger', {
          'app-sidebar__module-trigger_swap': isCollapsed
        })}
        onClick={handleTriggerClick}
        aria-label="Open module selector"
      >
        {isCollapsed ? (
          <>
            <span className="app-sidebar__module-trigger-logo">
              <BrandIcon />
            </span>
            <span className="app-sidebar__module-trigger-grid">
              <AppsGridIcon />
            </span>
          </>
        ) : (
          <AppsGridIcon />
        )}
      </button>
      {!isCollapsed && (
        <span className="app-sidebar__wordmark">
          <WordmarkIcon />
        </span>
      )}
    </div>
  );
};

export default observer(SidebarHeader);
